export default __webpack_public_path__ + "static/media/art.ad5f032f.svg";